var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_photo_library"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_1808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_1808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "photo_library",
    d: "M13.3461 21.1905H27.1979L22.7403 15.2424L18.9768 20.0693L16.5114 17.029L13.3461 21.1905ZM10.9903 26.9808C10.3456 26.9808 9.79341 26.751 9.33371 26.2913C8.87401 25.8316 8.64416 25.2794 8.64416 24.6347V6.09627C8.64416 5.45157 8.87401 4.89937 9.33371 4.43967C9.79341 3.97997 10.3456 3.75012 10.9903 3.75012H29.5287C30.1734 3.75012 30.7256 3.97997 31.1853 4.43967C31.645 4.89937 31.8748 5.45157 31.8748 6.09627V24.6347C31.8748 25.2794 31.645 25.8316 31.1853 26.2913C30.7256 26.751 30.1734 26.9808 29.5287 26.9808H10.9903ZM10.9903 25.0962H29.5287C29.6441 25.0962 29.7499 25.0482 29.846 24.952C29.9422 24.8558 29.9903 24.7501 29.9903 24.6347V6.09627C29.9903 5.98087 29.9422 5.8751 29.846 5.77895C29.7499 5.68277 29.6441 5.63468 29.5287 5.63468H10.9903C10.8749 5.63468 10.7691 5.68277 10.673 5.77895C10.5768 5.8751 10.5287 5.98087 10.5287 6.09627V24.6347C10.5287 24.7501 10.5768 24.8558 10.673 24.952C10.7691 25.0482 10.8749 25.0962 10.9903 25.0962ZM6.47115 31.5C5.82642 31.5 5.27422 31.2701 4.81455 30.8104C4.35485 30.3507 4.125 29.7986 4.125 29.1539V8.73087H6.00956V29.1539C6.00956 29.2692 6.05765 29.375 6.15383 29.4712C6.24998 29.5673 6.35575 29.6154 6.47115 29.6154H26.8941V31.5H6.47115Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.d94149955a9d76d80ee008a0dde159cf.svg";
export { ForwardRef as ReactComponent };